import script from "./FooterPublic.vue?vue&type=script&setup=true&lang=js"
export * from "./FooterPublic.vue?vue&type=script&setup=true&lang=js"

import "./FooterPublic.vue?vue&type=style&index=0&id=3f852c4a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3f852c4a"]])

export default __exports__